import { render, staticRenderFns } from "./AIClientContent.vue?vue&type=template&id=6f041bdd&scoped=true&"
import script from "./AIClientContent.vue?vue&type=script&lang=js&"
export * from "./AIClientContent.vue?vue&type=script&lang=js&"
import style0 from "./AIClientContent.vue?vue&type=style&index=0&id=6f041bdd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f041bdd",
  null
  
)

export default component.exports